import React, {useState, useEffect} from 'react';
import Papa from 'papaparse';
import { StyledBlockDataFlexStart, StyledDiv } from '../../Components/Styled';
import { Autocomplete, TextField, Typography } from '@mui/material';
import readXlsxFile from 'read-excel-file';
import { createRequestData, getRequestDataWithoutToken } from '../../Utility/apiHelper';
import BiztantuFooterButton from '../../Components/FotterButton';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { useSnackbar } from 'notistack';
import BiztantuLoader from '../../Components/Loader';
import { handleValidateCodevalue } from '../../Utility/constant';
import { useSelector } from 'react-redux';
const ExternalCampaignLayout = () => {

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [selectedtemplate, setSelectedTemplate] = useState(null);
    const [requiredError, setRequirederror] = useState(false);
    const [dataGridData, setDatagridData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    useEffect(() => {
        handlegetAllNotification();
      },[])
  
    const handlegetAllNotification = async() => {

        const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification`;
        const responseData = await getRequestDataWithoutToken(url);
        const {data} = responseData;

        setDatagridData(data);

    }

    const handleSelectFile = (event) => {
        const file = event.target.files[0];
        
        
        const selectedFiledata = [];

        if(file?.type == "text/csv") {
            Papa.parse(file, {
                complete: (result) => {

                    const headerColumn = result.data[0];

                    result.data?.shift();

                    // const myObject = myArray.reduce((acc, key, index, array) => {
                    //     if (index % 2 === 0) {
                    //       const value = array[index + 1];
                    //       acc[key] = value;
                    //     }
                    //     return acc;
                    // }, {});

                    result.data?.map((item, index) => {
                        
                        const myObject = item?.reduce((acc, key, index, array) => {
                            const value = array[index];
                            const Objectkey = headerColumn[index];
                            acc[Objectkey] = value;
                            return acc;
                        }, {});
    
                        selectedFiledata?.push(myObject);
                    })

                    setSelectedFile(selectedFiledata);
                },
              });
        }

        if(file?.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            readXlsxFile(file).then((rows) => {
                
                const headerColumn = rows[0];

                rows?.shift();

                rows?.map((item, index) => {
                        
                    const myObject = item?.reduce((acc, key, index, array) => {
                        const value = array[index];
                        const Objectkey = headerColumn[index];
                        acc[Objectkey] = value;
                        return acc; 
                    }, {});

                    selectedFiledata?.push(myObject);
                })

                setSelectedFile(selectedFiledata);
                  
            })
        }

    }

    const handleSelectMultiRoles = (event, roles, reason) => {
        setSelectedTemplate(roles);
    }

    const handleCustomBackbutton = () => {
        history.push(`${privateRoutesPath?.BIZTANTU_CAMPAIGN}`);
    }

    const handleSendNotification = async() => {

        if(selectedtemplate) {

            setIsLoading(true);

            const reqbody = {
                receipentList: selectedFile,
                emailSubject: selectedtemplate?.subject,
                templateBody: selectedtemplate?.templateBody,
                document_id: selectedtemplate?.document_id,
                type: "External",
                templateId: selectedtemplate?.id
            }

            const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/send-bulk-email`;
            const responseData = await createRequestData(reqbody,url);


            if(responseData?.status == 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.data), {variant: "success"})
            }
            else{
                enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN'),{variant:'error'})
            }

            setIsLoading(false);
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"SELECT_FILE_AND_TEMPLATE_WARNING"), {variant: "warning"} )
        }
    } 

    return (
        <BiztantuLoader isChildren={true} open = {isLoading}>
            <Typography variant='h6'>
                {handleValidateCodevalue(internationalise,'CAMP_NOTIFY_EXTERNAL_LEAD')}
            </Typography>
            {/* <Divider /> */}
            <StyledBlockDataFlexStart>

                <StyledDiv style={{width: "30%"}}>
                    <input required accept='*' type="file" onChange={handleSelectFile}/>
                </StyledDiv>

                <StyledDiv style={{width: "30%"}}>
                    <Autocomplete
                        options={dataGridData}
                        // sx={{width: true ? '100% !important' : "65ch !important", padding: "7px", display: 'flex'}}
                        sx={{width: "100%"}}
                        getOptionLabel={(option) => option?.name}
                        filterSelectedOptions = {true}
                        onChange={handleSelectMultiRoles}
                        disabled = {selectedFile ? false : true}
                          
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            error={selectedtemplate ? false : requiredError}
                            required
                            label={handleValidateCodevalue(internationalise,'CAMP_SELECT_TEMP')}
                            disabled = {selectedFile ? false : true}
                            sx={{width: "100%"}}
                            // sx={{width: true ? '100% !important' : "65ch !important" , padding: "7px" }}
                            InputLabelProps={{
                            shrink: true,
      
                        }}
                        />
                        )}
                    />
                </StyledDiv>
            </StyledBlockDataFlexStart>

            <BiztantuFooterButton 
                isiconRequired={false}
                actionlabel={handleValidateCodevalue(internationalise,'COMMON_SEND')}
                isBackbtnreq={true}
                handleCustomBackbutton={handleCustomBackbutton}
                redirecturl=""
                handleActionButton={ handleSendNotification}
                backButtonLabel={handleValidateCodevalue(internationalise,'COMMON_BACK')}
            />
            
        </BiztantuLoader>
    )
}

export default ExternalCampaignLayout;